const skillsData = {
  "Problem Solving": [
    "LeetCode (300+ problems)",
    "Data Structures & Algorithms", 
    "Competitive Programming"
  ],
  "Web Technologies": [
    "React.js",
    "Tailwind CSS", 
    "JavaScript",
    "HTML/CSS",
    "Responsive Design"
  ],
  "Backend Development": [
    "Django",
    "Express.js",
    "Node.js",
    "RESTful APIs",
    "Authentication"
  ],
  "Databases": [
    "MongoDB",
    "MySQL",
    "Database Design"
  ],
  "DevOps & Cloud": [
    "Git/GitHub",
    "Basic CI/CD",
    "Docker (Basics)",
    "AWS Cloud Basics"
  ],
  "Design & Tools": [
    "Bootstrap",
    "Figma (UI)",
    "Canva",
    "Chrome Extension APIs"
  ],
  "Others": [
    "Postman",
    "Fundamentals of Data Science"
  ],
  "Soft Skills": [
    "Time Management",
    "Teamwork", 
    "Leadership",
    "Communication"
  ]
};

// For backward compatibility
const skills = [
  "Python", "React", "Django", "Tailwind CSS", "JavaScript", 
  "MongoDB", "MySQL", "AWS", "Data Science", "Chrome APIs", 
  "Node.js", "Express", "Git", "Bootstrap", "Figma"
];

export { skillsData };
export default skills;
